import { API } from 'aws-amplify';

const orderLocalNumber = async (number, email, name) => {
  const newNumber = await API.post('agentbuzz', 'numbers', {
    body: { number, email, name },
  });
  return newNumber;
};

export default orderLocalNumber;



// WEBPACK FOOTER //
// ./src/services/phoneNumber/orderLocalNumber.js